/**
 * Created by JackCui on 2021/12/22
 */

import emitter, * as vm from 'fe-coms-share/utils/emitter.js'

export const childVm = vm.childVm
export const parentVm = vm.parentVm
export default emitter
